var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sources)?_c('div',{staticClass:"source flxrow"},_vm._l((_vm.sources),function(it,index){return _c('div',{key:index,staticClass:"link-text marginlr",on:{"click":function($event){return _vm.jumpSource(it)}}},[_vm._v(" Source ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }